import * as React from 'react';

const Logo = () => <img src={require('../../../../docs/assets/logo-simple.png')} alt="Piral Logo" />;

export default Logo;
